<div class="play-section">
  <div class="notification-bar">
    <div class="no-kryptomon" *ngIf="!hasKryptomonV2 && !hasKryptomonV1">
      <p>Hey! Looks like you don't have any Kryptomon yet, you need at least one in order to play!</p>
      <p>Use the "KryptoFinder" to find your first Kryptomon!</p>
      <div class="btn-finder" (click)="goToWizard()">Open KryptoFinder</div>
    </div>
    <div class="only-v1" *ngIf="!hasKryptomonV2 && hasKryptomonV1">
      <p>Looks like all of your Kryptomons are still in the limbo.</p>
      <p>Migrate them in order to play!</p>
      <div class="btn-finder" (click)="goToKryptomons()">Migrate Kryptomons</div>
    </div>
    <div class="some-v1" *ngIf="hasKryptomonV2 && hasKryptomonV1">
      <p>Looks like some of your Kryptomons are still in the limbo. Migrate them in order to use them in game!</p>
      <div class="btn-finder" (click)="goToKryptomons()">Migrate Kryptomons</div>
    </div>
    <div class="download-app" *ngIf="hasKryptomonV2 && !isMobile">
      <img src="./assets/img/Home/cellphone-wok.png" class="download-app-img-left"/>
      <div class="download-app-content">
        <!-- <p>Remember, multiplayer works only on our Mobile App! Download it now:</p> -->
        <div class="user-content user-content-desktop">
          <img class="user-device-icon" src="./assets/img/Icon/Icon-Desktop.svg" />
          <p class="user-title">Desktop</p><div class="line-sep"></div>
          <p class="user-text">Login with the same user and password and start playing!</p>
        </div>
        <div class="user-content user-content-mobile">
          <img class="user-device-icon" src="./assets/img/Icon/Icon-Mobile.svg" />
          <p class="user-title">Mobile</p><div class="line-sep"></div>
          <p class="user-text">Download the app here:</p>
          <div class="download-buttons">
            <div class="android-download download" (click)="playAndroid()">
              <img src="./assets/img/Home/Button-Android.svg" />
            </div>
            <div class="android-download download" (click)="playiOs()">
              <img src="./assets/img/Home/Button-iOS.svg" />
            </div>
          </div>
        </div>
      </div>
      <img src="./assets/img/Home/cellphones-game.png" class="download-app-img-right"/>
    </div>
    <div class="download-app" *ngIf="hasKryptomonV2 && isMobile">
      <img src="./assets/img/Home/cellphone-wok.png" class="download-app-img-left"/>
      <div class="download-app-content">
        <p class="user-mobile-text">The web version of the game doesn't run on Mobile. Download the app here:</p>
        <div class="user-content user-content-desktop">
          <img class="user-device-icon" src="./assets/img/Icon/Icon-Desktop.svg" />
          <p class="user-title">Desktop</p><div class="line-sep"></div>
          <p class="user-text">Login with the same user and password and start playing!</p>
        </div>
        <div class="user-content user-content-mobile">
          <img class="user-device-icon" src="./assets/img/Icon/Icon-Mobile.svg" />
          <p class="user-title">Mobile</p><div class="line-sep"></div>
          <p class="user-text">Download the app here:</p>
          <div class="download-buttons">
            <div class="android-download download" (click)="playAndroid()">
              <img src="./assets/img/Home/Button-Android.svg" />
            </div>
            <div class="android-download download" (click)="playiOs()">
              <img src="./assets/img/Home/Button-iOS.svg" />
            </div>
          </div>
        </div>
      </div>
      <img src="./assets/img/Home/cellphones-game.png" class="download-app-img-right"/>
    </div>
  </div>
  <div class="game-frame" *ngIf="hasKryptomonV2 && !isMobile">
    <iframe src="https://kryptomon-web.nyc3.cdn.digitaloceanspaces.com/index.html" allowfullscreen=true webkitallowfullscreen=true mozallowfullscreen=true></iframe>
  </div>
</div>
